module.exports = __webpack_public_path__ + "img/3.419f49e9.jpg";